import { Component, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DocumentService } from '../../services/document-service';

@Component({
  selector: 'app-pdf-preview',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (safeUrl(); as url) {
      <div class="pp__backdrop" (click)="docSvc.closePdfPreview()">
        <div class="pp__modal" (click)="$event.stopPropagation()">
          <div class="pp__hdr">
            <span class="pp__hdr-title">Ayuda memoria</span>
            <button class="pp__close" (click)="docSvc.closePdfPreview()" type="button" title="Cerrar">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>
          <iframe class="pp__iframe" [src]="url" title="Vista previa PDF"></iframe>
        </div>
      </div>
    }
  `,
  styles: [`
    .pp__backdrop {
      position: fixed; inset: 0; z-index: 9999;
      background: rgba(0,0,0,0.55);
      display: flex; align-items: center; justify-content: center;
      animation: pp-fade 0.2s ease both;
    }
    .pp__modal {
      width: 90vw; height: 90vh; max-width: 1200px;
      background: #fff; border-radius: 12px;
      display: flex; flex-direction: column;
      overflow: hidden; box-shadow: 0 20px 60px rgba(0,0,0,0.3);
      animation: pp-scale 0.2s ease both;
    }
    .pp__hdr {
      display: flex; align-items: center; justify-content: space-between;
      padding: 12px 16px; border-bottom: 1px solid #eee;
      flex-shrink: 0;
    }
    .pp__hdr-title { font-size: 13px; font-weight: 700; color: #222; }
    .pp__close {
      all: unset; cursor: pointer; display: flex;
      padding: 4px; border-radius: 6px; color: #666;
      transition: background 0.2s, color 0.2s;
    }
    .pp__close:hover { background: #f0f0f0; color: #111; }
    .pp__iframe { flex: 1; border: none; width: 100%; }
    @keyframes pp-fade { from { opacity: 0; } to { opacity: 1; } }
    @keyframes pp-scale { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
  `],
})
export class PdfPreviewComponent {
  protected readonly docSvc = inject(DocumentService);
  private readonly _sanitizer = inject(DomSanitizer);

  protected readonly safeUrl = computed<SafeResourceUrl | null>(() => {
    const url = this.docSvc.pdfPreviewUrl();
    return url ? this._sanitizer.bypassSecurityTrustResourceUrl(url) : null;
  });
}
